module.exports = __webpack_public_path__ + "static/img/shu.013200e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shu.png
// module id = Llgz
// module chunks = 0